import { FC } from "react";
import CardBody from "./card-body";
import CardImage from "./card-image";
import { twMerge } from "tailwind-merge";
import Link from "next/link";
import { useLayoutContext } from "@context/layout";
import Label from "../label";
import { useCardAction } from "./useCartAction";
import { FOLDER_STATUS, ICard } from "./types";
import { LABEL_COLOR, LABEL_STYLE } from "../label/label";

const ListCard: FC<ICard & { href: string; isFestival?: boolean }> = (
  props
) => {
  const { openCouponModal } = useCardAction();
  const { subscriptionData } = useLayoutContext();

  const hasPurchasableCoupon = Boolean(props.details_expire?.can_purchase);
  const openCouponModalHandler = () => {
    if (hasPurchasableCoupon)
      openCouponModal({
        id: props.id,
        price: props.price as number,
        sku: props.sku,
        title: props.title,
        expire: props.details_expire,
        slug: props.slug,
        type: props.type,
      });
  };

  const hasActiveSubscription = Boolean(subscriptionData?.is_active);
  const shouldRenderSubscriptionBadge = Boolean(
    hasActiveSubscription && props.showSubscriptionBadge
  );

  return (
    <Link
      href={props.href}
      prefetch={false}
      target={props.linkTarget || "_self"}
      onClick={(e) => {
        if (hasPurchasableCoupon) {
          e.preventDefault();
          e.stopPropagation();
          openCouponModalHandler();
        }
      }}
    >
      <div
        className={twMerge(
          "border-fds-cart hover:shadow-brand-md sm:p-4 py-4 flex  px-2.5  w-full",
          props.noBorder ? "border rounded-8" : "border-b",
          props.folderStatus === FOLDER_STATUS.FOLDER_SELECT
            ? "border-fds-brand"
            : "",
          hasPurchasableCoupon ? "relative pb-8" : ""
        )}
      >
        <div>
          <CardImage
            svg_image={props.svg_image}
            png_image={props.png_image}
            webp_image={props.webp_image}
            svg_featured_image={props.svg_featured_image}
            png_featured_image={props.png_featured_image}
            webp_featured_image={props.webp_featured_image}
            type={props.type}
            slug={props.slug}
            sku={props.sku}
            variant={props.variant}
            isFavorite={props.isFavorite}
            id={props.id}
            title={props.title_short || props.title}
            festival={props.festival}
            showDiscountIcon={props.showShoppingCart}
            isList
            changeFavorite={props.changeFavorite}
            folderStatus={props.folderStatus}
            handleFolderAction={props.handleFolderAction}
            showFolderIcon={props.showFolderIcon}
            details_expire={undefined}
            showSubscriptionBadge={props.showSubscriptionBadge}
          />
          {shouldRenderSubscriptionBadge && (
            <Label
              color={LABEL_COLOR.DEFAULT}
              style={LABEL_STYLE.FILL}
              className="w-full body-md rounded-full text-center justify-center mt-1 h-5"
            >
              اشتراک
            </Label>
          )}
        </div>

        <div className="mr-2 sm:mr-6 w-full">
          <CardBody {...props} />
        </div>
      </div>
    </Link>
  );
};
export default ListCard;
